import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Browser from '@wetransfer/concorde-browser';

import VideoIllustration from '@component/illustration/video-illustration';
import I18n from '@module/i18n';
import { getIsForwardedTransfer } from '@app/transfer-bundle/store/selectors';

const determineCopy = (transfer, mobile = false) => {
  if (mobile) {
    return transfer.expiry === 'never'
      ? I18n.t('transfer.complete_mobile.email_text_no_expiry')
      : I18n.t('transfer.complete_mobile.email_text', {
          expires: I18n.relativeTime(transfer.expiry_seconds),
        });
  }
  return transfer.expiry === 'never'
    ? I18n.t('transfer.complete_email.text_no_expiry')
    : I18n.t('transfer.complete_email.text', {
        expires: I18n.relativeTime(transfer.expiry_seconds),
      });
};

const Email = ({ isForwardedTransfer, transfer, onRequestClose }) => {
  const description = determineCopy(transfer, Browser.isMobile);

  const title = isForwardedTransfer
    ? I18n.t('transfer.complete_forward.title')
    : I18n.t('transfer.complete_email.title');

  return (
    <React.Fragment key="email">
      <div className="transfer__contents">
        <VideoIllustration
          type="transfer-complete-upload"
          src="transfer_window/transfer_completed"
          variants={3}
          className="uploader__image"
        />
        <h2>{title}</h2>
        <p
          dangerouslySetInnerHTML={{
            __html: description,
          }}
          className="complete__text"
        />
        <span className="transfer__contents--spacer" />
      </div>
      <div className="transfer__footer">
        <button className="transfer__button" onClick={onRequestClose}>
          {I18n.t('transfer.buttons.done')}
        </button>
      </div>
    </React.Fragment>
  );
};

Email.propTypes = {
  transfer: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  isForwardedTransfer: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  transfer: state.transfer,
  isForwardedTransfer: getIsForwardedTransfer(state),
});

export { Email };
export default connect(mapStateToProps)(Email);
